import { API_DATE_FORMAT } from 'appConstants';
import dayjs from 'dayjs';
import { addMethod, string } from 'yup';

addMethod(string, 'isValidDate', function (message) {
  return this.test('isValidDate', message, function (date) {
    if (!date) {
      return false;
    }
    const value = dayjs(date, API_DATE_FORMAT);

    return value.isValid();
  });
});

addMethod(string, 'isFutureDate', function (message) {
  return this.test('isFutureDate', message, function (date) {
    if (!date) {
      return false;
    }
    const value = dayjs(date, API_DATE_FORMAT);
    if (!value.isValid()) {
      return false;
    }

    return value.isSameOrAfter(dayjs(), 'day');
  });
});

addMethod(string, 'isPastDate', function (message) {
  return this.test('isPastDate', message, function (date) {
    if (!date) {
      return false;
    }
    const value = dayjs(date, API_DATE_FORMAT);
    if (!value.isValid()) {
      return false;
    }

    return value.isSameOrBefore(dayjs(), 'day');
  });
});

addMethod(string, 'maxDate', function (message, maxDate) {
  return this.test('maxDate', message, function (date) {
    if (!date) {
      return false;
    }
    const value = dayjs(date, API_DATE_FORMAT);
    const maxDateObj = dayjs(maxDate, API_DATE_FORMAT);
    if (!value.isValid() || !maxDateObj.isValid()) {
      return false;
    }

    return value.isSameOrBefore(maxDateObj, 'day');
  });
});

addMethod(string, 'minDate', function (message, minDate) {
  return this.test('minDate', message, function (date) {
    if (!date) {
      return false;
    }
    const value = dayjs(date, API_DATE_FORMAT);
    const minDateObj = dayjs(minDate, API_DATE_FORMAT);
    if (!value.isValid() || !minDateObj.isValid()) {
      return false;
    }
    return value.isSameOrAfter(minDateObj, 'day');
  });
});

declare module 'yup' {
  interface StringSchema {
    isFutureDate(message: string): StringSchema;
    isPastDate(message: string): StringSchema;
    isValidDate(message: string): StringSchema;
    maxDate(message: string, maxDate: string): StringSchema;
    minDate(message: string, minDate: string): StringSchema;
  }
}
